import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';

export const isCaptchaRequired = (client = getDefaultClient()) => {
  const projectSettings = client.projectSettings;

  assertDefined(projectSettings, 'Project settings are not available');

  return projectSettings.security.hCaptcha?.enabled ?? false;
};
